export const SubmitApprovalModalViewProps = {
  HEADING:
    'Thank you for submitting your product carbon footprint information!',
  CONTENT:
    'One of our in house LCA experts has already been notified and will review all information provided within 2 business days. In the meantime, we encourage you to review the preliminary results of your footprint in the Product Dashboard. To ensure integrity of the Product Carbon Footprint as well as protect your brand, you are required to wait until the review has been completed to download and start using your Product Carbon Footprint Label. We also strongly recommend to wait until the review has been completed before sharing any information externally or for official purposes. Once the review is completed, you will be notified by email as well as through our platform.',
  CHECKBOX_CONTENT:
    'Please check this box to indicate you have read the above message and proceed to your product dashboard',
  IN_REVIEW: 'in-review',
  COMMODITY_HEADING: 'Thank you for submitting your commodity carbon footprint information!',
  COMMODITY_CONTENT: 'One of our in house LCA experts has already been notified and will review all information provided within 2 business days. To ensure integrity of the Commodity Carbon Footprint as well as protect your brand, you are required to wait until the review has been completed. We also strongly recommend to wait until the review has been completed before sharing any information externally or for official purposes. Once the review is completed, you will be notified by email as well as through our platform.',
  COMMODITY_CHECKBOX_CONTENT: 'Please check this box to indicate you have read the above message'
};

export const FieldLabels = {
  CHECKBOX_NAME: 'condition',
};

export const ButtonLabels = {
  SUBMIT: 'Submit',
  CANCEL: 'Cancel',
};

export const initialValues = {
  condition: false,
};
